import React, { useContext, useEffect, useState } from 'react';

import { Tabs } from 'flowbite';

import { PacksContext, PacksDispatchContext } from './ApiProvider';
import CategoriesToPacks from './CategoriesToPacks';
import ExpensePacksDashboard from './ExpensePacksDashboard';
import ItemsToPacks from './ItemsToPacks';
import PackItemsByCategory from './PackItemsByCategory';
import PackItemsImportBar from './PackItemsImportBar';
import PacksToVenues from './PacksToVenues';

import Button from 'CommonComponents/Button';

export default function ContractorPacks(props) {
    const [tabs, setTabs] = useState(null);
    const [isAddItemButtonVisible, setIsAddItemButtonVisible] = useState(null);
    const [isAddPackButtonVisible, setIsAddPackButtonVisible] = useState(false);
    const [isAddCategoryButtonVisible, setIsAddCategoryButtonVisible] = useState(false);

    const apiCall = useContext(PacksDispatchContext);
    const { contractorPackItems, contractorPacks, contractorPackCategories, isLoaded } = useContext(PacksContext);

    const fetchUrl = () => {
        const url = new URL(props.fetchDashboardUrl);
        url.searchParams.set('type', 'contractor');

        return url.toString();
    };

    useEffect(function () {
        const tabsElement = $('#contractor-packs-tabs');
        const tabElements = [
            {
                id: 'dashboard-contractor-pack',
                triggerEl: document.querySelector('#dashboard-contractor-pack-tab'),
                targetEl: document.querySelector('#dashboard-contractor-pack'),
            },
            {
                id: 'contractor-pack-categories',
                triggerEl: document.querySelector('#contractor-pack-categories-tab'),
                targetEl: document.querySelector('#contractor-pack-categories'),
            },
            {
                id: 'contractor-pack-items',
                triggerEl: document.querySelector('#contractor-pack-items-tab'),
                targetEl: document.querySelector('#contractor-pack-items'),
            },
            {
                id: 'contractor-pack-packs',
                triggerEl: document.querySelector('#contractor-pack-packs-tab'),
                targetEl: document.querySelector('#contractor-pack-packs'),
            },
            {
                id: 'contractor-pack-assign-venues',
                triggerEl: document.querySelector('#contractor-pack-assign-venues-tab'),
                targetEl: document.querySelector('#contractor-pack-assign-venues'),
            },
        ];
        const options = {
            defaultTabId: 'dashboard-contractor-pack',
            activeClasses: 'active',
            inactiveClasses: 'inactive',
            onShow: (tabs, tab) => {
                setIsAddItemButtonVisible(tab.id === 'contractor-pack-items');
                setIsAddPackButtonVisible(tab.id === 'contractor-pack-packs');
                setIsAddCategoryButtonVisible(tab.id === 'contractor-pack-categories');
            },
        };
        const instanceOptions = {
            id: 'contractor-packs-tabs',
            override: true,
        };
        const tabs = new Tabs(tabsElement, tabElements, options, instanceOptions);

        setTabs(tabs);
    }, []);

    const handlePackItemEdit = (id) => {
        apiCall('form', {
            type: 'createContractorItem',
            id,
        });
    };

    const handleAddItem = () => {
        const activeTab = tabs.getActiveTab();

        if (activeTab.id === 'contractor-pack-items') {
            apiCall('form', { type: 'createContractorItem' });
        } else if (activeTab.id === 'contractor-pack-packs') {
            apiCall('form', { type: 'createContractorPack' });
        }
    };

    const handleAddCategory = () => {
        apiCall('form', { type: 'createContractorCategory' });
    };

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-space-y-6">
            <div
                className="in-nav horizontal"
                data-tabs-active-classes="active"
                data-tabs-inactive-classes="inactive"
                data-default-tab-id="contractor-pack-items-tab"
                data-tabs-toggle="#contractor-packs-tab-content"
                role="tablist"
                id="contractor-packs-tabs"
            >
                <button
                    className="in-nav__item"
                    id="dashboard-contractor-pack-tab"
                    data-tabs-target="#dashboard-contractor-pack"
                    type="button"
                    role="tab"
                    aria-controls="dashboard-contractor-pack"
                    aria-selected="true"
                >
                    {$t('Dashboard')}
                </button>
                <button
                    className="in-nav__item"
                    id="contractor-pack-categories-tab"
                    data-tabs-target="#contractor-pack-categories"
                    type="button"
                    role="tab"
                    aria-controls="contractor-pack-categories"
                    aria-selected="false"
                >
                    {$t('Categories')}
                </button>
                <button
                    className="in-nav__item"
                    id="contractor-pack-items-tab"
                    data-tabs-target="#contractor-pack-items"
                    type="button"
                    role="tab"
                    aria-controls="contractor-pack-items"
                    aria-selected="true"
                >
                    {$t('Items')}
                </button>
                <button
                    className="in-nav__item"
                    id="contractor-pack-packs-tab"
                    data-tabs-target="#contractor-pack-packs"
                    type="button"
                    role="tab"
                    aria-controls="contractor-pack-packs"
                    aria-selected="false"
                >
                    {$t('Cost Packs')}
                </button>
                <button
                    className="in-nav__item"
                    id="contractor-pack-assign-venues-tab"
                    data-tabs-target="#contractor-pack-assign-venues"
                    type="button"
                    role="tab"
                    aria-controls="contractor-pack-assign-venues"
                    aria-selected="false"
                >
                    {$t('Assign to Venue')}
                </button>

                {!!window.canSave && (isAddItemButtonVisible || isAddPackButtonVisible || isAddCategoryButtonVisible) && (
                    <div className="tw-flex tw-items-center tw-gap-x-1 !tw-ml-auto">
                        {isAddCategoryButtonVisible ? (
                            <Button small variant="primary" onClick={handleAddCategory}>
                                {$t('Add Category')}
                            </Button>
                        ) : (
                            <Button small variant="primary" onClick={(e) => handleAddItem()}>
                                {isAddPackButtonVisible ? $t('Add Pack') : $t('Add Item')}
                            </Button>
                        )}
                    </div>
                )}
            </div>
            <div id="contractor-packs-tab-content" className="tw-min-h-0">
                <div id="dashboard-contractor-pack" role="tabpanel" aria-labelledby="dashboard-contractor-pack-tab">
                    <ExpensePacksDashboard fetchDashboardUrl={fetchUrl()} />
                </div>
                <div id="contractor-pack-categories" className="tw-h-full" role="tabpanel" aria-labelledby="contractor-pack-categories-tab">
                    <CategoriesToPacks categories={contractorPackCategories} isContractor={true} isLoaded={isLoaded} />
                </div>
                <div id="contractor-pack-items" className="tw-h-full" role="tabpanel" aria-labelledby="contractor-pack-items-tab">
                    <div className="tw-flex tw-flex-col tw-h-full tw-space-y-2 tw-overflow-auto">
                        {!!window.canSave && <PackItemsImportBar type="contractor" />}
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                            <div className="tw-p-2.5 tw-flex tw-gap-2 tw-text-sm tw-font-semibold tw-text-charcoal tw-text-center">
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                    <div className="tw-text-left">{$t('Description')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between tw-text-center">
                                    <div>{$t('Rate Per Hour')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                    <div>{$t('Start Time Prior to Session Starting')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                    <div>{$t('Finish Time After Session Finishes')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                    <div>{$t('Min Shift Duration')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                    <div>{$t('Max Shift Duration')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-flex tw-flex-col tw-justify-between">
                                    <div>{$t('Shift Overlap Period')}</div>
                                </div>
                                {!!contractorPackItems.some((item) => item.can_be_edited) && <div className="tw-basis-6 tw-shrink-0"></div>}
                            </div>
                        </div>
                        <PackItemsByCategory items={contractorPackItems} categories={contractorPackCategories} type="contractor" onEdit={handlePackItemEdit} />
                    </div>
                </div>
                <div id="contractor-pack-packs" className="tw-h-full" role="tabpanel" aria-labelledby="contractor-pack-packs-tab">
                    <ItemsToPacks items={contractorPackItems} packs={contractorPacks} isLoaded={isLoaded} isContractor={true} />
                </div>
                <div id="contractor-pack-assign-venues" className="tw-h-full" role="tabpanel" aria-labelledby="contractor-pack-assign-venues-tab">
                    <PacksToVenues packs={contractorPacks} />
                </div>
            </div>
        </div>
    );
}
